import { render, staticRenderFns } from "./SmartProfileParameters.vue?vue&type=template&id=5799265b&"
import script from "./SmartProfileParameters.vue?vue&type=script&lang=ts&"
export * from "./SmartProfileParameters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports